import LocationOffIcon from "@mui/icons-material/LocationOff";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Stack, Typography } from "@mui/material";

import { QuoteEquipmentDisplay } from "components/QuoteEquipmentDisplay";
import { useRoleContext } from "hooks";
import {
  getNoteLabel,
  getQuoteSenderLabel,
  getQuoteTitle,
  ISOStringToLocalReadableTimestamp,
  ISOStringToReadableNotLocalized,
} from "utils";

import { PartnerQuoteChip } from "../../../PartnerQuoteChip";
import { QuoteStatusBadge } from "../../../QuoteStatusBadge";
import { CarrierCompanyQuoteDetail } from "../ShipmentQuoteDetail/components/CarrierCompanyQuoteDetaill";

interface Props {
  quote: ShipperCondensedQuote;
}

export function MultiShipmentProjectQuoteDetail(props: Props) {
  const { quote } = props;
  const { role } = useRoleContext();
  return (
    <Stack
      id="quote-details-stack"
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      spacing={1}
      width="100%"
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <QuoteStatusBadge status={quote.internal_state} size="small" />
        <PartnerQuoteChip quote={quote} />
        <Typography variant="h4">{getQuoteTitle(quote)}</Typography>
      </Stack>
      <Typography variant="body1" color="#0c4985">
        {getQuoteSenderLabel(quote, role)}
      </Typography>
      <CarrierCompanyQuoteDetail quote={quote} />
      {quote?.internal_state === "DECLINED" && quote?.decline_feedback && (
        <Typography>
          <b>Decline Reason: </b>
          {quote.decline_feedback}
        </Typography>
      )}
      <Typography>
        <Typography>
          <u>
            <b>Minimum Loads: </b>
            {quote?.min_loads_desired ?? "-"}
          </u>
        </Typography>
        <Typography>
          <u>
            <b>Maximum Loads: </b>
            {quote?.max_loads_desired ?? "-"}
          </u>
        </Typography>
        <QuoteEquipmentDisplay equipmentType={quote?.equipment_type} />
      </Typography>
      <Typography>
        <b>Pickup ETA: </b>
        {quote?.pickup_start
          ? ISOStringToReadableNotLocalized(quote.pickup_start)
          : "-"}
      </Typography>
      <Typography>
        <b>Last Pickup ETA: </b>
        {quote?.delivery_eta
          ? ISOStringToReadableNotLocalized(quote.delivery_eta)
          : "-"}
      </Typography>
      <Stack direction="row" alignItems="center">
        <Typography>
          <b>{"Tracking Link: "}</b>
          {quote?.tracking_link_offered ? "Yes" : "No"}
        </Typography>
        {quote.tracking_link_offered ? (
          <LocationOnIcon fontSize="small" color="success" />
        ) : (
          <LocationOffIcon fontSize="small" />
        )}
      </Stack>
      <Typography
        variant="body1"
        sx={{
          whiteSpace: "normal",
          overflow: "hidden",
          textOverflow: "ellipsis",
          wordBreak: "break-word",
          maxWidth: "100%",
        }}
      >
        <b>{`${getNoteLabel(role)} `}</b>
        {quote?.notes ?? ""}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
      >{`Submited ${ISOStringToLocalReadableTimestamp(quote.created_at)}`}</Typography>
    </Stack>
  );
}
